export enum ResponseResultCode {
    Ok = 200,
    Unauthorized = 401,
    NotFound = 404,
    Expired = 498,
    Forbidden = 403,
    ServerError = 500,
    NotValidData = 422,
    MultipleChoices = 300
}